var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "752pt",
    height: "752pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m522.81 151.05h-293.62c-43.098 0-78.141 35.043-78.141 78.141v293.62c0 43.098 35.047 78.141 78.141 78.141h293.62c43.098 0 78.141-35.047 78.141-78.141v-293.62c0-43.098-35.047-78.141-78.141-78.141zm-56.832 286.52c8.0508 8.0508 8.0508 20.363 0 28.414-3.7891 3.7891-8.9961 5.6836-14.207 5.6836-5.2109 0-10.418-1.8945-14.207-5.6836l-61.566-61.562-61.562 61.562c-3.7891 3.7891-8.9961 5.6836-14.207 5.6836-5.2109 0-10.418-1.8945-14.207-5.6836-8.0508-8.0508-8.0508-20.363 0-28.414l61.566-61.566-61.57-61.562c-8.0508-8.0508-8.0508-20.363 0-28.414 8.0508-8.0508 20.363-8.0508 28.414 0l61.566 61.566 61.566-61.566c8.0508-8.0508 20.363-8.0508 28.414 0 8.0508 8.0508 8.0508 20.363 0 28.414l-61.562 61.562z",
    fill: "#8b0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b4006250b5eec2897c1ab0d3331f7277.svg";
export { ForwardRef as ReactComponent };